import * as React from 'react'
import { useMemo } from 'react'
import BaseTaskOverview, { BaseTaskOverviewProps, TaskFilterType } from '../Task/BaseTaskOverview'

export default function TaskOverview(props?: BaseTaskOverviewProps) {
    const fixedFilterValues = useMemo<Partial<TaskFilterType>>(
        () => ({
            files: props.fileId ? [props.fileId] : undefined,
        }),
        [],
    )

    return <BaseTaskOverview {...props} fixedFilterValues={fixedFilterValues} />
}
